export const eventSHA = 'eventSHA';
export const paramString = 'country';

export const fbPixelId = 1560174350951119;

export const fbAccessToken =
  'EAAJh4zXCjn8BAIkyT7HNkon7apbWiXR5v9lGzpUxjrrNHqdkdeCq0ShkC8UDQL0ZB6vvmcyAQmFtRSj7oPjbeonMK3IUUW30xZAnsmTD3ENm1t2X8na3z4HMUUFwHcli3QxfAiWVG3b3nYO0NeFEZABIeM0NUCB46Eq9TJ4IOEbv1UTLt3h';

export const payOnlineDiscount = 49;
export const payOnlineDiscountAbove4k = 200;
export const OvalunaPrepaidIds = [
  3408, 3662, 3663, 3666, 3600, 3664, 3665, 3435,
];
